export default __webpack_public_path__ + "static/media/lettermixup_standard.71ad91fb.svg";